import React from "react";
import Aux from "../utils/AuxFunctions";
import "./Account.css"
import Fire from "../config/Fire";
import { withMyDataContext } from "../context/DataProvider";
import ErrorMessage from "../utils/ErrorPages/ErrorMessage";
import SucessMessage from "../utils/ErrorPages/SucessMessage";
import Colors from "../utils/Colors";
import DialogModal from "../utils/Utilities/DialogModal";
import ButtonLoader from "../utils/Utilities/ButtonLoader";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import TextInputMaterial from "../utils/Utilities/TextInputMaterial";
import LoadingHelper from "../utils/Utilities/LoadingHelper";
class DeleteUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmText: "",
            deleting: false,
            error: "",
            deleteDialog: false,
        }
    }

    deleteAccount = async () => {
        if (this.state.deleting)
            return
        if (this.state.confirmText !== "DELETE") {
            this.setState({ error: 'You have to write "DELETE"' })
            return
        }
        try {
            this.setState({ deleting: true })
            await Fire.shared.deleteAccount().then((didDelete) => {
                if (didDelete) {
                    this.setState({ sucess: true })
                    this.props.myDataProvider.signOut();
                    this.setState({ deleting: false })
                    this.props.history.push('/')
                } else {
                    this.setState({ error: "An unexpected error has occurred", deleting: false, confirmText: "" })
                }
                this.setState({ deleting: false })

            })
        } catch (error) {
            Aux.handleError(error)
            this.setState({ error: "An unexpected error has occurred", deleting: false, confirmText: "" })
        }
    }

    goBack = () => {
        try {
            this.props.history.goBack()
        } catch (error) {
            Aux.handleError(error)
        }
    }

    render() {

        return (
            <div style={{ width: "100%" }}>
                <section className="container">
                    <DialogModal active={this.state.deleteDialog} onConfirm={this.deleteAccount} onClose={() => this.setState({ deleteDialog: false })} text="Are you sure you want to delete your account?" />
                    {/* <img alt="logo" src={Aux.LogoImage} style={{ width: 50, objectFit: "contain" }}></img> */}
                    <div className="reversed-button-hover" style={{ display: "flex", alignItems: "center", }} onClick={this.goBack}>
                        <ChevronLeftIcon style={{ marginRight: 5 }}></ChevronLeftIcon>
                        <h2>Delete account</h2>
                    </div>
                    {this.props.myDataProvider.user ?
                        <div style={{ marginTop: 30 }}>
                            <span style={{ color: "#777", alignSelf: "center", fontSize: 14, }}>
                                Deleting your account, will make you lose all your in-app currency and the rights to all your previous posts
                        </span>
                            <SucessMessage isSucess={this.state.sucess}></SucessMessage>
                            <ErrorMessage text={this.state.error}></ErrorMessage>
                            <div style={{ margin: "20px 0" }}>
                                <span>To Confirm write "DELETE" below </span>

                                <TextInputMaterial type="text" placeholder="Write DELETE(uppercase)"
                                    style={{ marginTop: 5 }}
                                    value={this.state.confirmText}
                                    onChange={(e) => {
                                        this.setState({ confirmText: e.target.value, error: "" });
                                    }}
                                />
                            </div>
                            <ButtonLoader
                                text="Delete Account"
                                loading={this.state.deleting}
                                style={{ backgroundColor: Colors.red, width: "100%", height: 45 }}
                                // icon={FacebookIcon}
                                onClick={() => this.setState({ deleteDialog: true })}
                            ></ButtonLoader>

                        </div>
                        :
                        <LoadingHelper />
                    }
                </section>
            </div>
        );
    }
}

export default withMyDataContext(DeleteUser);